import React from "react";

const AttendanceSummaryTable = ({ payout, onViewDates }) => {
  return (
    <table className="mt-8 w-full">
      <thead>
        <tr>
          <th className="font-bold py-3 px-4 bg-[color:var(--color1)] text-white"></th>
          <th
            colSpan="4"
            className="font-bold py-3 px-4 bg-[color:var(--color1)] text-white"
          >
            Attendance Details
          </th>
          <th className="font-bold py-3 px-4 bg-[color:var(--color1)] text-white">
            <button
              className="text-center bg-gray-200 py-1 px-2 rounded cursor-pointer text-gray-700 roboto font-semibold text-sm hover:bg-gray-300 ml-6"
              onClick={() => onViewDates("present")}
            >
              Curr. Month
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="font-bold border py-3 px-4 text-center">
            Worked Days
          </td>
          <td className="font-bold border py-3 px-4 text-center">Late Days</td>
          <td className="font-bold border py-3 px-4 text-center">
            Penalty Days
          </td>
          <td className="font-bold border py-3 px-4 text-center">Paid Leaves</td>
          <td className="font-bold border py-3 px-4 text-center">
            Absent Days
          </td>
          <td className="font-bold border py-3 px-4 text-center">Holidays</td>
        </tr>
        <tr>
          <td className="border py-3 px-4 text-center">
            {payout?.total_working_days}
          </td>
          <td className="border py-3 px-4 text-center">
            {payout?.total_late_days}
          </td>
          <td className="border py-3 px-4 text-center">
            {payout?.late_penalty_days}
          </td>
          <td className="border py-3 px-4 text-center">
            {payout?.total_leave_days}
          </td>
          <td className="border py-3 px-4 text-center">
            {payout?.total_absent_days}
          </td>
          <td className="border py-3 px-4 text-center">
            {payout?.total_holidays}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default AttendanceSummaryTable;
